/**
 * Returns the Panamá states list to populate the select item.
 */
 export function gluky_addressfield_pa_states_list() {
  let temporalStates = [];
  const states = {
    '01': 'Provincia de Bocas del Toro',
    '02': 'Provincia de Chiriquí',
    '03': 'Provincia de Coclé',
    '04': 'Provincia de Colón',
    '05': 'Provincia del Darién',
    '06': 'Provincia de Herrera',
    '07': 'Provincia de Los Santos',
    '08': 'Provincia de Panamá',
    '09': 'Provincia de Panamá Oeste',
    '10': 'Provincia de Veraguas',
    '11': 'Comarca Emberá-Wounaan',
    '12': 'Comarca Guna Yala',
    '13': 'Distritos de Ngäbe-Buglé',
  };
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Panamá cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_pa_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '01':
    {
      '01002': 'Almirante',
      '01003': 'Bocas del Toro',
      '01004': 'Changuinola',
      '01005': 'Chiriquí Grande',
    },
    '02':
    {
      '02002': 'Alanje',
      '02003': 'Barú',
      '02004': 'Boquerón',
      '02005': 'Boquete',
      '02006': 'Bugaba',
      '02007': 'David',
      '02008': 'Dolega',
      '02009': 'Gualaca',
      '02010': 'Remedios',
      '02011': 'Renacimiento',
      '02012': 'San Félix',
      '02013': 'San Lorenzo',
      '02014': 'Tierras Altas',
      '02015': 'Tolé',
    },
    '03':
    {
      '03003': 'Aguadulce',
      '03004': 'Antón',
      '03005': 'La Pintada',
      '03006': 'Natá',
      '03007': 'Olá',
      '03008': 'Penonomé',
    },
    '04':
    {
      '04004': 'Colón',
      '04005': 'Chagres',
      '04006': 'Donoso',
      '04007': 'Portobelo',
      '04008': 'Santa Isabel',
    },
    '05':
    {
      '05005': 'Chepigana',
      '05006': 'Pinogana',
    },
    '06':
    {
      '06006': 'Chitré',
      '06007': 'Las Minas',
      '06008': 'Los Pozos',
      '06009': 'Ocú',
      '06010': 'Parita',
      '06011': 'Pesé',
      '06012': 'Santa María',
    },
    '07':
    {
      '07007': 'Guararé',
      '07008': 'Las Tablas',
      '07009': 'Los Santos',
      '07010': 'Macaracas',
      '07011': 'Pedasí',
      '07012': 'Pocrí',
      '07013': 'Tonosí',
    },
    '08':
    {
      '08008': 'Balboa',
      '08009': 'Chepo',
      '08010': 'Chimán',
      '08011': 'Panamá',
      '08012': 'San Miguelito',
      '08013': 'Taboga',
    },
    '09':
    {
      '09009': 'Arraiján',
      '09010': 'Capira',
      '09011': 'Chame',
      '09012': 'La Chorrera',
      '09013': 'San Carlos',
    },
    '10':
    {
      '10010': 'Atalaya',
      '10011': 'Calobre',
      '10012': 'Cañazas',
      '10013': 'La Mesa',
      '10014': 'Las Palmas',
      '10015': 'Mariato',
      '10016': 'Montijo',
      '10017': 'Río de Jesús',
      '10018': 'San Francisco',
      '10019': 'Santa Fe',
      '10020': 'Santiago',
      '10021': 'Soná',
    },
    '11':
    {
      '11011': 'Cémaco',
      '11012': 'Sambú',
    },
    '12':
    {
      '12012': 'Comarca Guna Yala',
    },
    '13':
    {
      '13013': 'Besikó',
      '13014': 'Kankintú',
      '13015': 'Kusapín',
      '13016': 'Mironó',
      '13017': 'Müna',
      '13018': 'Nole Düima',
      '13019': 'Ñürüm',
      '13020': 'Jirondai',
      '13021': 'Santa Catalina o Calovébora',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

